import React, { createContext, useContext, useState } from "react";

interface SidebarMenuContextValue {
  isSidebarMenuOpen: boolean;
  setIsSidebarMenuOpen: (open: boolean) => void;
}

export const SidebarMenuContext = createContext<SidebarMenuContextValue>({
  isSidebarMenuOpen: false,
  setIsSidebarMenuOpen: () => {},
});

export const useSidebarMenuContext = () => {
  return useContext(SidebarMenuContext);
};

interface SidebarMenuContextProviderProps {
  children: React.ReactNode;
}

export const SidebarMenuContextProvider = ({
  children,
}: SidebarMenuContextProviderProps) => {
  const [isSidebarMenuOpen, setIsSidebarMenuOpen] = useState(false);

  return (
    <SidebarMenuContext.Provider value={{ isSidebarMenuOpen, setIsSidebarMenuOpen }}>
      {children}
    </SidebarMenuContext.Provider>
  );
};
